export const MarkdownExtension = "md";

const ItemExtensions = ["md", "yaml", "yml"];

export default ItemExtensions;
